import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Main from 'layouts/Main';
import Container from 'components/Container';
import './components/indexView.css';
// import FunctionsHomeView from './components/FunctionsHomeView';

const IndexView = () => {
  const theme = useTheme();
  return (
    <Main bgcolor={'background.paper'}>
      {/* <Container>
        <Services />
      </Container> */}
      <Box
        sx={{
          backgroundImage: `linear-gradient(to bottom, ${alpha(
            theme.palette.background.paper,
            0,
          )}, ${alpha(theme.palette.alternate.main, 1)} 100%)`,
          backgroundRepeat: 'repeat-x',
          position: 'relative',   
          height: '650px'       
        }}
      >
        <Container>
        </Container>
      </Box>
    </Main>
  );
};

export default IndexView;
